import AssessmentEditor from './AssessmentEditor';

export default AssessmentEditor;
